import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./context/AuthContext"; 
import "./index.css";
import App from "./App";

// Obtendo o elemento root do HTML
const root = ReactDOM.createRoot(document.getElementById("root"));

// Renderizando a aplicação corretamente
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
